// extracted by mini-css-extract-plugin
export var hackaway5logoClass = "v5-module--hackaway5logoClass--2S-SB";
export var video = "v5-module--video--3fCCL";